module.exports = __webpack_public_path__ + "static/img/table.f359193.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/table.jpg
// module id = Pojj
// module chunks = 1